export const routePaths = {
  root: "/",
  orders: "/orders",
  restaurants: "/restaurants",
  menus: "/menus",
  promotions: "/promotions",
  documentation: "/documentation",
  help: "/help",
};
